import highcharts from 'highcharts/highstock'
import highmaps from 'highcharts/highmaps'

import localeFR from '../locales/fr/index.js'
import * as colors from './colors'

const dateTimeLabelFormats = {
  millisecond: '%d-%m-%Y',
  second: '%d-%m-%Y',
  minute: '%d-%m-%Y',
  hour: '%d-%m-%Y',
  day: '%d-%m-%Y',
  week: '%m-%Y',
  month: '%m-%Y',
  year: '%Y'
}

const dateTimeGroupingLabelFormats = Object.entries(dateTimeLabelFormats).reduce((obj, [key, value]) => {
  obj[key] = [value]
  return obj
}, {})

const options = {
  global: {
    useUTC: false
  },
  chart: {
    backgroundColor: null
  },
  exporting: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  xAxis: {
    dateTimeLabelFormats: dateTimeLabelFormats,
    minRange: 2,
    labels: {
      style: {
        color: colors.daddy,
        fontWeight: '600',
        textTransform: 'uppercase'
      }
    }
  },
  yAxis: {
    labels: {
      style: {
        color: colors.daddy,
        fontWeight: '600'
      }
    }
  },
  series: {
    dataGrouping: {
      dateTimeLabelFormats: dateTimeGroupingLabelFormats
    }
  },
  tooltip: {
    dateTimeLabelFormats: dateTimeLabelFormats,
    backgroundColor: colors.galaxy,
    borderWidth: 0,
    style: {
      color: 'white',
      fontWeight: 'bold'
    },
    useHTML: true,
    headerFormat: `<span style="color: ${colors.daddy}; font-size: 0.9rem;">{point.key}</span><br>`
  },
  navigator: {
    height: 8,
    xAxis: {
      gridLineWidth: 0,
      labels: {
        x: -15,
        y: 15
      },
      type: 'datetime',
      dateTimeLabelFormats: {
        month: '%b \'%y',
        year: '%Y'
      }
    },
    outlineWidth: 0,
    maskFill: colors.galaxy
  },
  rangeSelector: {
    enabled: false
  },
  scrollbar: {
    enabled: false
  },
  lang: {
    loading: localeFR.highcharts.loading,
    months: localeFR.highcharts.months,
    weekdays: localeFR.highcharts.weekdays,
    shortMonths: localeFR.highcharts.shortMonths,
    exportButtonTitle: localeFR.highcharts.exportButtonTitle,
    printButtonTitle: localeFR.highcharts.printButtonTitle,
    rangeSelectorFrom: localeFR.highcharts.rangeSelectorFrom,
    rangeSelectorTo: localeFR.highcharts.rangeSelectorTo,
    rangeSelectorZoom: localeFR.highcharts.rangeSelectorZoom,
    downloadPNG: localeFR.highcharts.downloadPNG,
    downloadJPEG: localeFR.highcharts.downloadJPEG,
    downloadPDF: localeFR.highcharts.downloadPDF,
    downloadSVG: localeFR.highcharts.downloadSVG,
    resetZoom: localeFR.highcharts.resetZoom,
    resetZoomTitle: localeFR.highcharts.resetZoomTitle,
    thousandsSep: localeFR.highcharts.thousandsSep,
    decimalPoint: localeFR.highcharts.decimalPoint
  }
}

highcharts.setOptions(options)
highmaps.setOptions(options)
